import React, { forwardRef } from 'react';
import InputWithIcon from './InputWithIcon';

const DropdownWithIcon = forwardRef(({
  icon,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  children,
  disabled,
  required,
  name,
  ...otherProps
}, ref) => {
  return (
    <div className={`input-field ${error ? 'error' : ''}`}>
      <InputWithIcon
        icon={icon}
        placeholder={placeholder}
        select
        value={value || ''}
        error={error}
        onChange={onChange}
        name={name}
        required={required}
        disabled={disabled}
        displayEmpty
        ref={ref}
        {...otherProps}
      >
        {children}
      </InputWithIcon>
      {helperText && <div style={{color: '#d32f2f', textAlign: 'right'}}>{helperText}</div>}
    </div>
  );
});

export default DropdownWithIcon;